export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-v1-1200-558f6f19e529f0016267a47178ff2a1c.webp";